import React, {useState} from "react";
import TableList from "../../../component/TableList/TableList";
import {normalizeTimestemp} from "../../../utils/normalizeTimestemp";
import {numberWithPoints} from "../../../utils/numberWithPoints";
import FilterWriteOff from "./FilterWriteOff";
import PopupOrderDetails from "../../Order/Components/PopupOrderDetails";
import VisibilityIcon from "@mui/icons-material/Visibility";
import WriteOffActions from "./WriteOffActions";
import PopupExportEvento from "../../Event/Components/PopupExportEvento";
import {useUser} from "../../../auth/AuthProvider";
import PopupExportWriteOff from "./PopupExportWriteOff";

export default function WriteOffList({
                                         baseUrl, loadData,
                                         setLoadData, size, page,
                                         setTotalPages, setTotalElements,
                                         sort, setSort, setPage
                                     }) {

    const {user} = useUser()
    const initialFilter = {baixaManual: true}

    const [data, setData] = useState([])
    const [error, setError] = useState(false)
    const [filter, setFilter] = useState(initialFilter)

    const titles = [
        'Leilão',
        'Lote',
        'Parcela',
        'Vencimento',
        'Valor',
        'Status',
        'Baixa Manual'
    ]


    const label = <>
        Ver Lote <VisibilityIcon fontSize="medium"/>
    </>

    console.log(data);

    return (
        <>
            <FilterWriteOff
                filter={filter} setFilter={setFilter} setLoadData={setLoadData}
                setPage={setPage} initialFilter={initialFilter}/>
            <TableList
                titles={titles} baseUrl={baseUrl}
                page={page} sort={sort} size={size}
                loadData={loadData}
                setTotalPages={setTotalPages} setTotalElements={setTotalElements}
                setData={setData} setLoadData={setLoadData} filter={filter}
                error={error} setError={setError}
            >
                {data.map((item) =>
                    <tr key={item.id}>
                        <td>{item.pedido.evento.nomeEvento}</td>
                        <td>{item.pedidoNumero}</td>
                        <td>{item.numero}</td>
                        <td>{normalizeTimestemp(item.vencimento)}</td>
                        <td>R$ {numberWithPoints(item.valor)}</td>
                        <td>{item.status}</td>
                        <td>{item.baixaManual ? "Efetuada" : "Não efetuada"}</td>
                        <td><WriteOffActions item={item} setLoadData={setLoadData} label={label}/></td>
                    </tr>
                )}
            </TableList>
            <br/>
            {user?.isAdmin &&
                <PopupExportWriteOff filter={filter}/>
            }
        </>
    )
}